export const LEAD_INDICATION_EMPTY_MESSAGE = 'Nenhuma indicação enviada até o momento.';

export const LEAD_INDICATION_LOAD_ERROR_MESSAGE =
  'Não foi possível carregar as indicações. Tente novamente.';

export const LEAD_INDICATION_DOWNLOAD_ERROR_MESSAGE =
  'Não foi possível baixar a planilha. Tente novamente.';

export const LEAD_INDICATION_DOWNLOAD_LABEL = 'Baixar planilha preenchida';
